import { createSlice } from '@reduxjs/toolkit';
const initialState = {
    taskCount: 0,
};
const slice = createSlice({
    name: 'taskReducer',
    initialState,
    reducers: {
        updateTaskCount(state, action) {
            const { taskCount } = action.payload;
            state.taskCount = taskCount;
        },
    },
});
export const TaskActions = slice.actions;
export default slice.reducer;
